import core, { GQL } from '@gin-betting/core';
import matchList from '@gin-betting/match-list';
import { Middleware, MiddlewareAPI, TypedAction } from 'redux';

import { ExtendedRouts, matchListRoutes } from 'app-constants';
import { State } from 'types';

const {
    actions: { resetCategory, searchMatches },
} = matchList;
const {
    services: { getHistory },
    utils: { isOneOfPages },
    entities: {
        constants: { GROUP_GET_MATCHES_REQUEST },
    },
} = core;

function makeMatchListMiddleware(): Middleware {
    let prevPathname: string;

    return ({ dispatch }: MiddlewareAPI<State>) => {
        const history = getHistory();

        history.listen(({ pathname }) => {
            // TODO: check. may be we should reset category when user go out from matchList?
            if (!matchListRoutes.includes(pathname)) return;

            if (prevPathname && pathname !== prevPathname) {
                dispatch(resetCategory({ listType: prevPathname }));
            }

            prevPathname = pathname;
        });

        return next => (action: TypedAction) => {
            modifyActionRankOrder(action);

            return next(action);
        };
    };
}

function modifyActionRankOrder(action: TypedAction): void {
    if (
        !isMatchListGetMatchesAction(action) ||
        isOneOfPages([ExtendedRouts.RESULTS_LIST])
    ) {
        return;
    }

    if (isOneOfPages([ExtendedRouts.TOURNAMENT])) {
        action.payload.variables.order = GQL.SportEventOrder.RANK_DEFAULT;

        return;
    }

    action.payload.variables.order = GQL.SportEventOrder.RANK_PERSONALIZED;
}

function isMatchListGetMatchesAction(
    action: any
): action is ReturnType<typeof searchMatches> {
    return action.meta && action.meta.group === GROUP_GET_MATCHES_REQUEST;
}

export default makeMatchListMiddleware;
